import { render, staticRenderFns } from "./UpdateActivityGoodsDialog.vue?vue&type=template&id=04d4a9be&scoped=true&lang=pug&"
import script from "./UpdateActivityGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateActivityGoodsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4a9be",
  null
  
)

export default component.exports